import { __awaiter, __generator } from "tslib";
import { AddToCartActionOption } from '@wix/wixstores-client-core';
export function preloadCartByAction(ecomPlatformPublicAPI, action) {
    if (action === AddToCartActionOption.TINY_CART) {
        return ecomPlatformPublicAPI.cart.preloadTinyCart();
    }
    else if (action === AddToCartActionOption.MINI_CART) {
        return ecomPlatformPublicAPI.cart.preloadSideCart();
    }
    else if (action === AddToCartActionOption.CART) {
        return ecomPlatformPublicAPI.cart.preloadCartPage();
    }
}
export function calculateAddToCartCartAction(requestedAddToCartCartAction, hasCartIcon) {
    if (requestedAddToCartCartAction === AddToCartActionOption.NONE && !hasCartIcon) {
        return AddToCartActionOption.MINI_CART;
    }
    return requestedAddToCartCartAction !== null && requestedAddToCartCartAction !== void 0 ? requestedAddToCartCartAction : AddToCartActionOption.MINI_CART;
}
export function handleAddToCartAction(ecomPlatformPublicAPI, addToCartAction, addedProductId, catalogReference, onBeforeNavigationFallback) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(addToCartAction === AddToCartActionOption.MINI_CART)) return [3 /*break*/, 5];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ecomPlatformPublicAPI.cart.openSideCart()];
                case 2: return [2 /*return*/, _d.sent()];
                case 3:
                    _a = _d.sent();
                    onBeforeNavigationFallback === null || onBeforeNavigationFallback === void 0 ? void 0 : onBeforeNavigationFallback();
                    return [2 /*return*/, ecomPlatformPublicAPI.navigate.toCart()];
                case 4: return [3 /*break*/, 15];
                case 5:
                    if (!(addToCartAction === AddToCartActionOption.TINY_CART)) return [3 /*break*/, 14];
                    _d.label = 6;
                case 6:
                    _d.trys.push([6, 12, , 13]);
                    _b = catalogReference;
                    if (!_b) return [3 /*break*/, 8];
                    return [4 /*yield*/, ecomPlatformPublicAPI.cart.hasSuccessPopup()];
                case 7:
                    _b = (_d.sent());
                    _d.label = 8;
                case 8:
                    if (!_b) return [3 /*break*/, 10];
                    return [4 /*yield*/, ecomPlatformPublicAPI.cart.openSuccessPopup(catalogReference)];
                case 9: return [2 /*return*/, _d.sent()];
                case 10: return [4 /*yield*/, ecomPlatformPublicAPI.cart.showTinycart({ addedProductId: addedProductId })];
                case 11: return [2 /*return*/, _d.sent()];
                case 12:
                    _c = _d.sent();
                    onBeforeNavigationFallback === null || onBeforeNavigationFallback === void 0 ? void 0 : onBeforeNavigationFallback();
                    return [2 /*return*/, ecomPlatformPublicAPI.navigate.toCart()];
                case 13: return [3 /*break*/, 15];
                case 14:
                    if (addToCartAction === AddToCartActionOption.CART) {
                        onBeforeNavigationFallback === null || onBeforeNavigationFallback === void 0 ? void 0 : onBeforeNavigationFallback();
                        return [2 /*return*/, ecomPlatformPublicAPI.navigate.toCart()];
                    }
                    _d.label = 15;
                case 15: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=addToCart.utils.js.map